import { ACTIVITIES_LOADED, LOAD_ACTIVITIES, SYNC_FAILED } from './actionTypes';
import {
  IActivitiesAction,
  IActivitiesState,
  IFailedSyncAction,
  ISetActivitiesAction,
} from './types';

export const initialState = {
  error: null,
  loaded: false,
  sourceActivities: [],
  syncing: false,
  targetActivities: [],
};

export const reducer = (
  state: IActivitiesState = initialState,
  action: IActivitiesAction
): IActivitiesState => {
  switch (action.type) {
    case LOAD_ACTIVITIES:
      return { ...state, error: null, sourceActivities: [], syncing: true, targetActivities: [] };
    case ACTIVITIES_LOADED:
      return { ...state, ...(action as ISetActivitiesAction).payload, error: null, syncing: false };
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload, syncing: false };
    default:
      return state;
  }
};
